<template>
  <!-- プルダウン選択パーツ -->
  <div class="message disp-scroll" style="height: 500px; padding: 10px; overflow-y: scroll; background-color:white;">
    <!-- メインのメッセージ -->
    <p class="sub-message">※メッセージ内容とプルダウンのタイトルで引用リストが利用できます。</p>
    <p>メッセージ内容</p>
    <p style="font-size: 13px; padding:10px;">
      <b-field>
        <textarea class="textarea disp-scroll"
        placeholder="例：以下のプルダウンから選択してください。"
        v-model="scenarioEdit.mainmessage"
        :disabled="scenarioEdit.is_confirm"></textarea>
      </b-field>
    </p>
    <template >
      <div class="dot-line"></div>
      <div style="display:flex">
        <div v-if="filteredCustomColumns.length > 0 && !isColumnLoading">
          <p>応募者管理画面項目(全選択項目)</p>
          <b-select class="select colomn-name"
            v-model="scenarioEdit.company_column"
            :disabled="scenarioEdit.is_confirm"
            expanded>
              <option value=""></option>
              <option
                v-for="(comCol, idx) in filteredCustomColumns"
                :value="comCol"
                :key="idx + '-comCol'">
                {{getCustomName(comCol)}}
              </option>
          </b-select>
        </div>
        <div style="margin-left: 40px">
          <!-- インポート -->
          <label for="file_upload" class="make-bot-button">
            <p style="font-weight: bold;">インポート</p>
            <input type="file" id="file_upload" ref="file" @change="excelPulldownImport" :disabled="scenarioEdit.is_confirm">
          </label>
        </div>
        <div style="margin-left: 40px">
          <!-- エクスポート -->
          <label for="file_export" class="make-bot-button">
            <p style="font-weight: bold;">エクスポート</p>
            <button id="file_export" class="button is-success is-small" style="margin-right: 8px;" @click="excelPulldownExport()">
              <span class="mdi mdi-export"></span>
            </button>
          </label>
        </div>
      </div>
    </template>
    <div class="dot-line"></div>
    <!-- プルダウン -->
    <div v-for="(parameter, pulldownIdx) in scenarioEdit.parameter" :key="pulldownIdx">
      <b-collapse class="card" animation="slide" :open="false">
        <div slot="trigger" slot-scope="props" class="card-header" role="button">
          <div class="card-header-title">
            <span style="width:300px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">プルダウン{{pulldownIdx+1}}
              <span v-if="!props.open">：{{parameter.title}}</span>
            </span>
            <span style="font-size: 14px; color: gray; display: flex;">
              <span style="font-weight: normal;width: 60px;" v-if="!props.open">{{parameter.isRequired ? '必須*' : '任意'}}</span>
              <span style="width: 350px;white-space: nowrap;">
                <div style="font-weight: normal;overflow: hidden;text-overflow: ellipsis;" v-if="!props.open && parameter.custom_column">
                  応募者項目：{{getCustomName(parameter.custom_column)}}
                </div>
                <div style="font-weight: normal;overflow: hidden;text-overflow: ellipsis;" v-if="!props.open && parameter.refPullDownId!='None'">
                  連動：{{getPulldownName(parameter.refPullDownId)}} - {{getPulldownItemName(parameter.refPullDownId, parameter.refItemId)}}
                </div>
              </span>
            </span>
          </div>
          <a class="card-header-icon"><b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon></a>
        </div>
        <div class="card-content">
          <!-- プルダウンの追加 -->
          <p style="font-size: 13px; padding:10px;" v-if="pulldownIdx==0">
            <button class="button is-small is-fullwidth" @click="addPullDown(-1)" :disabled="scenarioEdit.is_confirm">
            <i class="mdi mdi-plus-box"></i>プルダウン1の上に追加</button>
          </p>
          <!-- プルダウン番号 -->
          <div>
            <div style="display: flex">
              <p style="text-align: left; font-weight: bold;">プルダウン{{pulldownIdx + 1}}の項目設定</p>
              <b-switch size="is-small"
                style="display: flex; align-items: left; padding-left: 15px;"
                v-model="parameter.isRequired"
                :disabled="scenarioEdit.is_confirm">
                {{parameter.isRequired ? '必須' : '任意'}}選択
              </b-switch>
            </div>
            <!-- 応募者情報に反映 -->
            <p style="margin-top: 4px;">応募者管理画面項目(プルダウン{{pulldownIdx + 1}}表示項目)</p>
            <b-select class="select colomn-name"
              placeholder="詳細項目"
              v-model="parameter.custom_column"
              :disabled="scenarioEdit.is_confirm"
              expanded>
                <option value=""></option>
                <option
                  v-for="(comCol, idx) in filteredCustomColumns"
                  :value="comCol"
                  :key="idx + '-comCol'">
                  {{getCustomName(comCol)}}
                </option>
            </b-select>
            <!-- 横に並べるかどうか -->
            <b-field style="padding-top: 16px;">
              <b-switch
                @input="isDispNextTitleFalse(scenarioEdit.parameter[pulldownIdx])"
                size="is-small"
                style="display: flex; align-items: left;"
                v-model="parameter.isLinking"
                v-if="pulldownIdx < scenarioEdit.parameter.length -1 && !lastPulldowns.includes(parameter.pullDownId)"
                :disabled="scenarioEdit.is_confirm">
                次のプルダウンと横に{{parameter.isLinking ? '並べる' : '並べない'}}
              </b-switch>
              <b-switch
                size="is-small"
                style="display: flex; align-items: left;"
                v-model="parameter.isDispNextTitle"
                v-if="pulldownIdx < scenarioEdit.parameter.length -1 && parameter.isLinking && prevSettingCheck(pulldownIdx) && !lastPulldowns.includes(parameter.pullDownId)"
                :disabled="scenarioEdit.is_confirm">
                次のプルダウンタイトルを表示{{parameter.isDispNextTitle ? 'する' : 'しない'}}
              </b-switch>
            </b-field>
            <div class="pulldown-box-form">
              <div class="pulldown-box-left">
                <div v-if="pulldownIdx > 0">
                  <!-- どのプルダウンに連動させるか(自分より上位のプルダウンのみ) -->
                  <p style="text-align: left; width: 100%;">
                    <span style="text-align: left;">連動する親プルダウンと項目の選択</span>
                    <b-select
                      class="select-wrapper"
                      size="is-small"
                      v-model="parameter.refPullDownId"
                      v-if="pulldownIdx > 0"
                      :disabled="scenarioEdit.is_confirm">
                      <option selected value="None">連動プルダウンなし</option>
                      <option v-for="(relation, titleIndex) in getRelationPullDowns(pulldownIdx)" :value="relation.pullDownId" :key="titleIndex">
                        {{relation.title}}
                      </option>
                    </b-select>
                    <!-- 連動させるプルダウンのどの項目に紐付けるか -->
                    <b-select class="select-wrapper" size="is-small" v-model="parameter.refItemId"
                      v-if="pulldownIdx > 0 && parameter.refPullDownId !== 'None'" :disabled="scenarioEdit.is_confirm">
                      <option v-for="(item, itemIndex) in getRelationItems(pulldownIdx)" :value="item.itemId" :key="itemIndex">
                        {{item.itemName}}
                      </option>
                    </b-select>
                  </p>
                </div>
              </div>
              <div class="pulldown-box-right">
                <p style="text-align: left; width: 100%;">
                  <!-- プルダウンに付属するタイトル -->
                  <span style="text-align: left;">プルダウン{{pulldownIdx + 1}}タイトル</span>
                  <span style="text-align: left;">
                    <input
                      class="input is-small"
                      style="width: 100%;"
                      placeholder="例) 以下から選択してください(30文字以内)"
                      maxlength="30"
                      v-model="parameter.title"
                      :disabled="scenarioEdit.is_confirm"/>
                  </span>
                  <br><br>
                  <!-- プルダウンに表示する項目 -->
                  <span style="text-align: left;">表示項目</span>
                  <span style="text-align: left;">
                    <div v-for="(item, itemIdx) in parameter.items" :key="itemIdx">
                      <b-field>
                        <input
                          class="input is-small"
                          style="width: 100%;"
                          placeholder="30文字以内で記載してください"
                          maxlength="30"
                          v-model="item.itemName"
                          :disabled="scenarioEdit.is_confirm"/>
                        <button
                          class="button is-small"
                          style="background: #f8f8f8;"
                          @click="addItem(pulldownIdx, itemIdx)"
                          :disabled="scenarioEdit.is_confirm">
                          <span class="mdi mdi-plus-box"></span>
                        </button>
                        <button
                          class="button is-small"
                          style="background: #f8f8f8;"
                          @click="delItem(pulldownIdx, itemIdx)"
                          v-if="parameter.items.length > 1"
                          :disabled="scenarioEdit.is_confirm">
                          <span class="mdi mdi-minus-box"></span>
                        </button>
                      </b-field>
                    </div>
                  </span>
                </p>
              </div>
            </div>
            <!-- プルダウンの追加 -->
            <p style="font-size: 13px; padding:10px;">
              <button
                class="button is-small is-fullwidth"
                @click="addPullDown(pulldownIdx)"
                :disabled="scenarioEdit.is_confirm">
                <i class="mdi mdi-plus-box"></i>プルダウン{{pulldownIdx + 1}}の下に追加
              </button>
            </p>
            <!-- プルダウンの削除 -->
            <p style="font-size: 13px; padding:10px;">
              <button
                class="button is-small is-fullwidth"
                @click="delPullDown(pulldownIdx)"
                v-if="scenarioEdit.parameter.length > 0"
                :disabled="scenarioEdit.is_confirm">
                <i class="mdi mdi-minus-box"></i>プルダウン{{pulldownIdx + 1}}の削除
              </button>
            </p>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import createUUID from '@/functions/createUUID'
export default {
  props: {
    scenarioEdit: {
      type: Object,
      required: true
    },
    filteredCustomColumns: {
      type: Array,
      required: true
    },
    isColumnLoading: {
      type: Boolean,
      required: true
    },
    getCustomName: {
      type: Function,
      required: true
    },
    /**
     * カスタムカラムの名前をキーにしてIDを取得
     */
    getCustomColumnId: {
      type: Function,
      required: true
    }
  },
  computed: {
    getRelationPullDowns: function () {
      // 選択可能な紐付け先プルダウンの一覧取得
      const self = this
      return function (idx) {
        let pullDowns = []
        for (let index in self.scenarioEdit.parameter) {
          if (index < idx) {
            // 自分より前のプルダウンをリストにする
            pullDowns.push(self.scenarioEdit.parameter[index])
          }
        }
        return pullDowns
      }
    },
    getRelationItems: function () {
      // 紐付け先プルダウンで選択したプルダウンの項目取得
      const self = this
      return function (idx) {
        let items = []
        const refPullDownId = self.scenarioEdit.parameter[idx].refPullDownId
        if (refPullDownId !== 'None') {
          for (const pullDown of self.scenarioEdit.parameter) {
            if (pullDown.pullDownId === refPullDownId) {
              items = pullDown.items
              break
            }
          }
        }
        return items
      }
    },
    lastPulldowns () {
      let hasChild = {}
      let lastChildOf = {'None': {}}
      for (const pulldown of this.scenarioEdit.parameter) {
        if (pulldown.refPullDownId !== 'None') {
          hasChild[pulldown.refPullDownId] = true
          if (!lastChildOf[pulldown.refPullDownId]) lastChildOf[pulldown.refPullDownId] = {}
          lastChildOf[pulldown.refPullDownId][pulldown.refItemId] = pulldown.pullDownId
        } else {
          lastChildOf['None'][''] = pulldown.pullDownId
        }
      }
      let ret = []
      for (const pulldown of this.scenarioEdit.parameter) {
        if (hasChild[pulldown.pullDownId]) continue
        if (pulldown.refPullDownId !== 'None' && lastChildOf[pulldown.refPullDownId][pulldown.refItemId] !== pulldown.pullDownId) continue
        if (pulldown.refPullDownId == 'None' && lastChildOf['None'][''] !== pulldown.pullDownId) continue
        ret.push(pulldown.pullDownId)
      }
      return ret
    },
  },
  methods: {
    getPulldownName(id) {
      const pulldown = this.scenarioEdit.parameter.find((pulldown)=>pulldown.pullDownId == id)
      return (pulldown ? pulldown.title : '')
    },
    getPulldownItemName(pulldown_id, item_id) {
      const pulldown = this.scenarioEdit.parameter.find((pulldown)=>pulldown.pullDownId == pulldown_id)
      if (!pulldown) return ''
      const item = pulldown.items.find((item) => item.itemId == item_id)
      return (item ? item.itemName : '')
    },
    isDispNextTitleFalse (obj) {
      if (obj.isLinking === true) {
        obj.isDispNextTitle = false
      }
    },
    prevSettingCheck (pulldownIdx) {
      if (this.scenarioEdit.parameter[pulldownIdx - 1]) {
        if (this.scenarioEdit.parameter[pulldownIdx - 1].isLinking === false) {
          return true
        } else {
          this.scenarioEdit.parameter[pulldownIdx].isDispNextTitle = false
          return false
        }
      } else {
        return true
      }
    },
    addPullDown (addIdx) {
      // プルダウン選択追加
      let isAdd = true
      if (addIdx === -1) {
        // 被参照チェック
        if (addIdx >= 0) {
          const pullDownId = this.scenarioEdit.parameter[addIdx].pullDownId
          for (const index in this.scenarioEdit.parameter) {
            if (index > addIdx) {
              // 追加インデックスの次から探す
              if (this.scenarioEdit.parameter[index].refPullDownId === pullDownId) {
                // 参照されているので確認メッセージ表示
                isAdd = confirm('連動するプルダウンとの間に追加しようとしています。\n追加してもよろしいですか？')
                break
              }
            }
          }
        }
      }
      // プルダウンの追加
      if (isAdd) {
        // OKであれば追加
        let pullDown = {
          pullDownId      : createUUID(),
          isRequired      : false,
          refPullDownId   : 'None',
          refItemId       : '',
          isLinking       : false,
          title           : '',
          isDispNextTitle : true,
          items           : [{itemId : createUUID(), itemName : ''}]
        }
        // 指定されたインデックスの次に挿入する
        this.scenarioEdit.parameter.splice(addIdx + 1, 0, pullDown)
      }
    },
    delPullDown (delIdx) {
      // プルダウン選択削除
      const pullDownId = this.scenarioEdit.parameter[delIdx].pullDownId
      const refPullDownId = this.scenarioEdit.parameter[delIdx].refPullDownId
      let isDell = false
      let isRef  = false
      let refIdx = []
      if (this.scenarioEdit.parameter.length > 0) {
        // 被参照チェック
        for (const index in this.scenarioEdit.parameter) {
          if (index < delIdx) {
            // 削除インデックスの前まで探す
            if (this.scenarioEdit.parameter[index].pullDownId === refPullDownId) {
              // 他のプルダウンを参照している
              isRef = true
            }
          } else if (index > delIdx) {
            // 削除インデックス以降を探す
            if (this.scenarioEdit.parameter[index].refPullDownId === pullDownId) {
              // 削除するプルダウンが参照されている
              refIdx.push(index)
            }
          }
        }
      }
      // プルダウンの削除確認
      let msg = ''
      if (refIdx.length > 0 || isRef) {
        // 参照されているので確認メッセージ表示
        msg = '削除しようとしているプルダウンは他のプルダウンと連動しています。\n削除しますがよろしいですか？'
      } else {
        // 参照はされてないけど、削除なので確認
        msg = '削除しますがよろしいですか？'
      }
      isDell = confirm(msg)
      // プルダウンの削除
      if (isDell) {
        // 参照をクリアする
        for (const idx of refIdx) {
          this.scenarioEdit.parameter[idx].refPullDownId = 'None'
          this.scenarioEdit.parameter[idx].refItemId     = ''
        }
        // 参照をクリアしてから削除する
        this.scenarioEdit.parameter.splice(delIdx, 1)
      }
      if (this.scenarioEdit.parameter.length === 0) {
        // 最後のプルダウンが削除された場合は、空のプルダウンを追加
        this.addPullDown(-1)
      }
    },
    addItem (pullDownIdx, addItemIdx) {
      // 項目を追加
      // 空の項目を作成
      let item = {
        itemId: createUUID(),
        itemName: ''
      }
      // 指定されたインデックスの次に挿入する
      this.scenarioEdit.parameter[pullDownIdx].items.splice(addItemIdx + 1, 0, item)
    },
    delItem (pullDownIdx, delItemIdx) {
      // 項目を削除
      const itemId = this.scenarioEdit.parameter[pullDownIdx].items[delItemIdx].itemId
      let isDell = true
      let refIdx = []
      // 被参照チェック
      for (const index in this.scenarioEdit.parameter) {
        if (index > pullDownIdx) {
          // 削除インデックス以降を探す
          if (this.scenarioEdit.parameter[index].refItemId === itemId) {
            // 削除する項目が参照されている
            refIdx.push(index)
          }
        }
      }
      // 項目の削除確認
      let msg = ''
      if (refIdx.length > 0) {
        // 参照されているので確認メッセージ表示
        msg = '削除しようとしている項目は他のプルダウンと連動しています。\n削除しますがよろしいですか？'
      } else {
        // 参照はされてないけど、削除なので確認
        msg = '削除しますがよろしいですか？'
      }
      isDell = confirm(msg)
      // 項目の削除
      if (isDell) {
        // 参照をクリアする
        for (const idx of refIdx) {
          this.scenarioEdit.parameter[idx].refPullDownId = 'None'
          this.scenarioEdit.parameter[idx].refItemId     = ''
        }
        // 参照をクリアしてから削除する
        this.scenarioEdit.parameter[pullDownIdx].items.splice(delItemIdx, 1)
      }
    },
    /**
     * プルダウンパーツ値インポート
     * @param  {Event} event ファイル選択オブジェクト
     */
     excelPulldownImport (event) {
      // エラー制御
      let errmsg = ""
      let errcount = 0

      // Excelファイルを読み込み
      let files = event.target.files || event.dataTransfer.files
      let reader = new FileReader()
      reader.onload = (event) => {
        let XLSX = require('xlsx')
        let Utils = XLSX.utils
        let arr = this.fixdata(event.target.result)
        let book = XLSX.read(btoa(arr), {
          type: 'base64',
          cellDates: true,
        })
        let urlListsSheet1 = book.Sheets['pulldownvalue']
        let pulldownlist = Utils.sheet_to_json(urlListsSheet1)
        let pulldownTitleDuplicateArray = []
        for (let pv in pulldownlist) {
          if (pulldownlist[pv]['応募者管理画面項目（各プルダウン）'] != undefined && pulldownlist[pv]['応募者管理画面項目（各プルダウン）'] != '') {
            let columnId = this.getCustomColumnId(pulldownlist[pv]['応募者管理画面項目（各プルダウン）'])
            if(columnId == null) {
              // カスタムカラム名が間違っている場合エラー設定
              errmsg += "カラム名間違い:"+pulldownlist[pv]['応募者管理画面項目（各プルダウン）']+"\n"
              errcount += 1
            }
          }
          // true or falseの設定値確認
          if (pulldownlist[pv]['必須'] != 0 && pulldownlist[pv]['必須'] != 1) {
            errcount += 1
            errmsg += "必須(0or1のみ):"+pulldownlist[pv]['必須']+"\n"
          }
          if (pulldownlist[pv]['横並び'] != 0 && pulldownlist[pv]['横並び'] != 1) {
            errcount += 1
            errmsg += "横並び(0or1のみ):"+pulldownlist[pv]['横並び']+"\n"
          }
          if (pulldownlist[pv]['次プルダウンタイトル表示'] != 0 && pulldownlist[pv]['次プルダウンタイトル表示'] != 1) {
            errcount += 1
            errmsg += "次プルダウンタイトル表示(0or1のみ):"+pulldownlist[pv]['次プルダウンタイトル表示']+"\n"
          }

          // プルダウンタイトル部分を集約するため
          pulldownTitleDuplicateArray.push(pulldownlist[pv]['タイトル'])
        }

        // プルダウンアイテムごとにレコードが作られているため、プルダウンタイトル毎に集約
        let pulldownTitleArray = [...new Set(pulldownTitleDuplicateArray)]
        let pulldownResult = []
        // プルダウンタイトル毎に繰り返し処理を行う。
        let firstrowcheck=0
        for (let pt in pulldownTitleArray) {
          // プルダウンアイテムのIDを付与（プルダウンタイトルに合致したレコードのみ）
          let pulldownItemArray = []
          for (let pv2 in pulldownlist) {
            if(pulldownTitleArray[pt] == pulldownlist[pv2]['タイトル']) {
              // 最初にセットされるプルダウンはプルダウンパーツの一番上のプルダウンとなり、親プルダウンが表示されないため、空白チェックをする。
              if(firstrowcheck == 0 && ((pulldownlist[pv2]['連動する親プルダウン'] != undefined && pulldownlist[pv2]['連動する親プルダウン'] != "") || (pulldownlist[pv2]['連動する親プルダウン表示項目'] != undefined && pulldownlist[pv2]['連動する親プルダウン表示項目'] != ""))) {
                errcount += 1
                errmsg += "最初のプルダウンの「連動する親プルダウン」の情報は空白にしてください"
              }
              pulldownItemArray.push(
                {
                  itemId: createUUID(),
                  itemName: pulldownlist[pv2]['表示項目']
                }
              )
            }
          }
          firstrowcheck += 1

          // プルダウンタイトル毎にjsonを作成
          for (let pv2 in pulldownlist) {
            if(pulldownTitleArray[pt] == pulldownlist[pv2]['タイトル']) {
              let requiredFlg = false
              if(pulldownlist[pv2]['必須'] == 1) {
                requiredFlg = true
              }
              let linkingFlg = false
              if(pulldownlist[pv2]['横並び'] == 1) {
                linkingFlg = true
              }
              let dispNextTitleFlg = false
              if(pulldownlist[pv2]['次プルダウンタイトル表示'] == 1) {
                dispNextTitleFlg = true
              }
              if (pulldownlist[pv2]['応募者管理画面項目（各プルダウン）'] == undefined || pulldownlist[pv2]['連動する親プルダウン'] == "") {
                pulldownResult.push({
                  pullDownId      : createUUID(),
                  isRequired      : requiredFlg,
                  refPullDownId   : "",
                  refItemId       : "",
                  isLinking       : linkingFlg,
                  title           : pulldownlist[pv2]['タイトル'],
                  isDispNextTitle : dispNextTitleFlg,
                  items           : pulldownItemArray
                })
              } else {
                let columnId = this.getCustomColumnId(pulldownlist[pv2]['応募者管理画面項目（各プルダウン）'])
                pulldownResult.push({
                  pullDownId      : createUUID(),
                  isRequired      : requiredFlg,
                  refPullDownId   : "",
                  refItemId       : "",
                  isLinking       : linkingFlg,
                  title           : pulldownlist[pv2]['タイトル'],
                  isDispNextTitle : dispNextTitleFlg,
                  items           : pulldownItemArray,
                  custom_column   : columnId
                })
              }
              break
            }
          }
        }

        // 紐づけエラー表示処理（参照タイトルと参照アイテムでプルダウンに合致するものがなかった場合、まとめてエラー表示）
        let idxChildrenPulldown=0
        let idxParentPulldown=0
        for (let pv in pulldownlist) {
          idxChildrenPulldown += 1
          for (let pr0 in pulldownResult) {
            let errflg = 1
            if(pulldownlist[pv]['タイトル'] == pulldownResult[pr0]['title'] && pulldownlist[pv]['連動する親プルダウン'] != undefined && pulldownlist[pv]['連動する親プルダウン'] != "" && pulldownlist[pv]['連動する親プルダウン表示項目'] != undefined && pulldownlist[pv]['連動する親プルダウン表示項目'] != "") {
              let pvTitleItem = pulldownlist[pv]['連動する親プルダウン']+pulldownlist[pv]['連動する親プルダウン表示項目']
              idxParentPulldown = 0
              for (let pr1 in pulldownResult) {
                for(let pr2 in pulldownResult[pr1]['items']) {
                  idxParentPulldown += 1
                  let pr2TitleItem = pulldownResult[pr1]['title']+pulldownResult[pr1]['items'][pr2]['itemName']
                  if(pvTitleItem == pr2TitleItem) {
                    if(idxChildrenPulldown > idxParentPulldown) {
                      pulldownResult[pr0]['refPullDownId'] = pulldownResult[pr1]['pullDownId']
                      pulldownResult[pr0]['refItemId'] = pulldownResult[pr1]['items'][pr2]['itemId']
                      errflg = 0
                      break
                    } else {
                      errflg = 2
                      break
                    }
                  }
                }
              }
              if(errflg == 1) {
                errcount += 1
                errmsg += "連動プルダウン間違い(プルダウン/表示項目):"+pulldownlist[pv]['連動する親プルダウン']+"/"+pulldownlist[pv]['連動する親プルダウン表示項目']+"\n"
              } else if(errflg == 2) {
                errcount += 1
                errmsg += "プルダウンの順番に誤りがあります:"+pulldownlist[pv]['連動する親プルダウン']+"/"+pulldownlist[pv]['連動する親プルダウン表示項目']+"\n"
              } 
            } else if(pulldownlist[pv]['タイトル'] == pulldownResult[pr0]['title']) {
              pulldownResult[pr0]['refPullDownId'] = "None"
              pulldownResult[pr0]['refItemId'] = ""
              break
            }
          }
        }

        if(errcount > 0) {
          alert('以下エラーが発生しています\n'+errmsg)
          // 指定ファイルをリセット
          this.$refs.file.value = null
        } else {
          this.scenarioEdit.parameter = pulldownResult
        }
      }
      reader.readAsArrayBuffer(files[0])

      // ダイアログを閉じる
      this.cancel()
    },
    fixdata (data) {
        let o = '',
            l = 0,
            w = 10240
        for (; l < data.byteLength / w; ++l) {
          o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)))
        }
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
        return o
    },
    excelPulldownExport () {
      this.$store.dispatch('chatbot/exportPulldown', {scenario_name: this.scenarioEdit.name, scenario_pk: this.scenarioEdit.pk})
    },
    /**
     * キャンセル
     */
     cancel () {
      this.$emit('cancel', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.message {
  background: #ffffff;
  max-height: calc(100vh - 300px);
  overflow: auto;
  padding: 8px;
}
.sub-message {
  color: #666;
  font-size: 12px;
  margin-bottom: 16px;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.pulldown-box-form {
  width: 100%; display: flex; padding: 8px;
}
.pulldown-box-left {
  width: 40%; font-size: 13px; padding: 10px; justify-content: flex-start; display: flex;
}
.pulldown-box-right {
  width: 60%; font-size: 13px; padding: 10px; justify-content: flex-start; display: flex;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalEditPulldownParts.vue